import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardContent, CardFooter } from "@/components/ui/card";
import { Mail, Loader2, Sparkles } from "lucide-react";
import MainLayout from "@/layouts/MainLayout.tsx";
import EmailService from "@/lib/email";

export default function EdgeFunctions() {
  const [loading, setLoading] = useState(false);

  const triggerEmailTest = async () => {
    setLoading(true);
    try {
      const { data, error } = await EmailService.sendEmail({
        to: "ashrafksalim1@gmail.com", // Test recipient
        subject: "Monitor Health AI - Test Email",
        body: "<h1>Test Email</h1><p>This is a test email from the migrated AWS SES service.</p>",
      });

      if (error) {
        toast.error("Email sending failed.");
        console.error("Email error:", error);
      } else {
        toast.success("Test email sent via AWS SES!");
        console.log("Email success:", data);
      }
    } catch (err) {
      toast.error("Unexpected error. Check console.");
      console.error("Unexpected error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="w-full sm:px-6">
        <Card className="rounded-2xl shadow-lg shadow-blue-100/40 border border-gray-200">
          <CardHeader className="border-b px-6 pt-6 pb-4">
            <div className="flex items-center mb-4">
              <Sparkles className="mr-3 text-blue-600" size={24} />
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
                Test Patient Email Notification
              </h2>
            </div>
            <p className="text-sm text-gray-500">
              Triggers Supabase Edge Function to send patient emails using ZeptoMail.
            </p>
          </CardHeader>

          <CardContent className="p-6 text-gray-700">
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Runs patient selection logic via Supabase RPC</li>
              <li>Sends styled email alerts</li>
              <li>Using authenticated function invocation</li>
            </ul>
          </CardContent>

          <CardFooter className="p-6 border-t">
            <Button
              onClick={triggerEmailTest}
              disabled={loading}
              className="w-full text-white font-semibold h-[56px] text-base rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 hover:scale-[1.02] transition-transform shadow-md shadow-blue-300/40"
            >
              {loading ? (
                <Loader2 className="animate-spin mr-2" size={18} />
              ) : (
                <Mail className="mr-2" size={18} />
              )}
              {loading ? "Sending..." : "Send Test Emails"}
            </Button>
          </CardFooter>
        </Card>
      </div>
    </MainLayout>
  );
}
